import {createMemoryHistory, createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import routes from './routes'
import {useAuthStore} from "src/stores/authStore";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

const Router = createRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash) {
        return {
          el: to.hash,
          behavior: 'smooth',
        }
      }
    }

  },
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
})

/**
 * Page de connexion demandée depuis l'application alors que l'utilisateur est connecté (bouton retour du
 * navigateur, en général) : la navigation est simplement annulée. Les boutons de déconnexion (et une session
 * expirée) déconnectent avant d'y aller : ils ne sont pas concernés.
 */
Router.beforeEach((to, from) => {
  if (to.path === "/Login" && from.matched.length && useAuthStore().isLoggedIn) return false;
  return true;
})

Router.beforeEach((to, from, next) => {
  const publicPages = ["/Login","/Register"]

  let authRequired = !publicPages.includes(to.path)

  if(!authRequired) next()

  const authStore = useAuthStore()
  const loggedIn = authStore.isLoggedIn

  if (authRequired && !loggedIn) {
    next("/Login");
  } else {
    if(to.path==='/Login' || loggedIn /*currentUser&&currentUser.hasToken*/) {
      next();
    }
    else {
      next("/Login");
    }
  }
})


export default Router;
